@use '@/styles/mastodon/mixins';

.root {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  isolation: isolate;

  // Approximate height of fixed navigation elements
  // to ensure focused elements are scrolled into view
  // as needed.
  --header-height: 80px;
  --footer-height: 200px;

  scroll-padding-block: var(--header-height) var(--footer-height);

  --navigation-background-color: var(--color-bg-desktop);

  &[data-mode='slide-out'] {
    --navigation-background-color: var(--color-bg-primary);
  }
}

.list {
  margin-top: var(--space-6);
  margin-inline: var(--space-4);
}

.newPostButton {
  margin-bottom: var(--space-4);
}

.footer {
  position: sticky;
  bottom: 0;
  margin-top: auto;
  padding: var(--space-6);
  padding-top: var(--space-1);
  background-color: var(--navigation-background-color);

  &::before {
    @include mixins.scroll-gradient(bottom, var(--navigation-background-color));

    opacity: 0;
    transition: opacity ease 250ms;
  }

  &[data-stuck='true']::before {
    opacity: 1;
  }

  @media (height < 560px) {
    position: relative;
    margin-top: var(--space-4);

    &::before {
      display: none;
    }
  }
}

.footerNav {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-1);
  margin-bottom: var(--space-2);
}

.callout {
  margin-inline: var(--space-4);
}
